import {observable, action} from 'mobx';
import _ from 'lodash';

class ClinicalNoteWritingTopicsStore {
  @observable topics = [];
  @observable topic = _.assign({}, {
    categoryId: 0,
    title: '',
    file: {}
  });
  @observable errors = {};

  @action
  setTopics = topics => {
    this.topics = topics;
  };

  @action
  initNewTopic = (categoryId) => {
   this.topic = _.assign({}, {
      categoryId,
      title: '',
      file: {}
    });
  };

  @action
  setError = errors => {
    this.errors = errors;
  };

  @action
  setTopic = topic => {
    this.topic = topic;
  };

  @action
  updateTopic = topic => {
    const allTopics = [...this.topics];
    let oldTopicIndex = allTopics.findIndex(e => e.id === topic.id);
    allTopics[oldTopicIndex] = topic;
    this.setTopics(allTopics); 
  }

  @action
  saveTopic = resource => {
    const allTopics = [...this.topics];
    allTopics.push(resource);
    this.setTopics(allTopics); 
  }

  getTopicById = id => {
    return this.topics.find(el => el.id === id);
  };

  @action
  handleUpdateTopic = newTopic => {
    let oldTopic = this.getTopicById(newTopic.id);
    _.assign(oldTopic, newTopic);
  };

  @action
  createTopic = topic => {
    this.topics.unshift(topic);
  };

  @action
  deleteTopic = id => {
    const allTopics = [...this.topics];
    let index = _.findIndex(allTopics, el => el.id === id);
    allTopics.splice(index, 1);
    this.setTopics(allTopics);
  };

  @action
  sortTopics = topics => {
    return topics.sort((topic_a, topic_b) => topic_a.title.localeCompare(topic_b.title));
  }

  @action
  handleChange = data => {
    _.assign(this.topic, data);
  }
}

export default new ClinicalNoteWritingTopicsStore();



// WEBPACK FOOTER //
// ./src/stores/clinicalNoteWritingTopicsStore.js